import React from 'react';

const Image = () => (
  <svg
    width="29"
    height="24"
    viewBox="0 0 29 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27 1H2C1.44772 1 1 1.44772 1 2V23H28V2C28 1.44772 27.5523 1 27 1Z"
      stroke="#0F1C35"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M5 23L12.0355 10.1666L16.4376 18.3555L19.1963 14.4444L23.5 23.0467"
      stroke="#0F1C35"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M22.4235 10.1667C23.5581 10.1667 24.4778 9.20908 24.4778 8.0278C24.4778 6.84653 23.5581 5.88892 22.4235 5.88892C21.2889 5.88892 20.3691 6.84653 20.3691 8.0278C20.3691 9.20908 21.2889 10.1667 22.4235 10.1667Z"
      stroke="#0F1C35"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
  </svg>
);

export default Image;
